// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.debug-overlay-module__overlay___T6rCP {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(49, 88, 94, 0.8);
  z-index: 9999;
  height: auto;
  min-height: 300px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 10px;
  font-family: "Courier New", Courier, monospace;
  display: flex;
  flex-direction: column;
  cursor: grab;
}
.debug-overlay-module__overlay___T6rCP input:not([type=checkbox]),
.debug-overlay-module__overlay___T6rCP button {
  height: 20px;
}

.debug-overlay-module__header___d9ze8 {
  display: flex;
  justify-content: space-between;
}
.debug-overlay-module__header___d9ze8 h2 {
  color: whitesmoke;
}

.debug-overlay-module__content___T_tPF {
  display: flex;
  justify-content: space-between;
  gap: 15px;
  border-top: 1px solid #ccc;
  padding-top: 10px;
  flex-wrap: wrap;
}

.debug-overlay-module__storagePanel___TapH2,
.debug-overlay-module__actionsPanel___ybFXR,
.debug-overlay-module__copyPanel___BolAy,
.debug-overlay-module__dynatracePanel___MZpBo {
  flex: 1;
  min-width: 200px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
  position: relative;
  padding-top: 10px;
}

.debug-overlay-module__storagePanel___TapH2 {
  flex: 0.4;
}

.debug-overlay-module__dynatracePanel___MZpBo {
  min-width: 220px;
}

.debug-overlay-module__cookiePanelDiv___HMbxB {
  margin-top: 20px;
}

.debug-overlay-module__storagePanel___TapH2 h3,
.debug-overlay-module__actionsPanel___ybFXR h3,
.debug-overlay-module__copyPanel___BolAy h3,
.debug-overlay-module__dynatracePanel___MZpBo h3 {
  left: 10px;
  margin: 0;
}

.debug-overlay-module__actionsPanel___ybFXR .debug-overlay-module__actionColumn___ji5yQ {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
.debug-overlay-module__actionsPanel___ybFXR .debug-overlay-module__actionColumn___ji5yQ button {
  text-align: left;
}
.debug-overlay-module__actionsPanel___ybFXR .debug-overlay-module__tokenSelect___l3OBV {
  width: 30%;
  height: 22px;
}
.debug-overlay-module__actionsPanel___ybFXR .debug-overlay-module__ottInput___rZgwe {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  justify-content: space-between;
}
.debug-overlay-module__actionsPanel___ybFXR .debug-overlay-module__ottInput___rZgwe input {
  flex: 2;
  width: 100%;
  margin-right: 10px;
}
.debug-overlay-module__actionsPanel___ybFXR .debug-overlay-module__ottInput___rZgwe button {
  flex: 1;
  width: 100px;
}

.debug-overlay-module__buttonRow___QOlIw {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  gap: 10px;
}
.debug-overlay-module__buttonRow___QOlIw button {
  flex: 1;
}

.debug-overlay-module__copyPanel___BolAy ul {
  list-style: none;
  padding: 0;
}

.debug-overlay-module__copyPanel___BolAy li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
  width: 100%;
  line-height: 1;
}

.debug-overlay-module__copyPanelButton___EJblD {
  margin-left: 10px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 50px;
}

.debug-overlay-module__copyPanel___BolAy button:disabled {
  cursor: not-allowed;
}

.debug-overlay-module__overlayButton___PrL3s {
  position: absolute;
  top: 6px;
  left: 20%;
  padding: 10px;
  cursor: pointer;
  font-size: 16px;
  color: #333;
  border-radius: 50%;
  min-width: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease, transform 0.2s ease;
  z-index: 10000;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.debug-overlay-module__datadogButtonsColumn___D9hch {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 10px;
}

.debug-overlay-module__datadogButton___hVbKB {
  margin: 0;
  width: 100%;
}

.debug-overlay-module__dynatracePanel___MZpBo .debug-overlay-module__dtSection___ON48W {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
}
.debug-overlay-module__dynatracePanel___MZpBo .debug-overlay-module__dtInlineRow___P4SPE {
  display: flex;
  gap: 5px;
  align-items: center;
}
.debug-overlay-module__dynatracePanel___MZpBo .debug-overlay-module__dtInlineRow___P4SPE input {
  flex: 1;
  min-width: 0;
}
.debug-overlay-module__dynatracePanel___MZpBo .debug-overlay-module__dtInlineRow___P4SPE button {
  white-space: nowrap;
  flex-shrink: 0;
}
.debug-overlay-module__dynatracePanel___MZpBo .debug-overlay-module__dtSectionSubtitle___hq9bj {
  font-weight: normal;
  color: #777;
}
.debug-overlay-module__dynatracePanel___MZpBo .debug-overlay-module__fullWidth___VL5tj {
  width: 100%;
}
.debug-overlay-module__dynatracePanel___MZpBo .debug-overlay-module__dtIconButton___vo2Tv {
  flex-shrink: 0;
  padding: 0 6px;
  font-size: 14px;
  line-height: 1;
}

.debug-overlay-module__consents___sIOPf {
  margin-block: 12px;
}
.debug-overlay-module__consents___sIOPf .debug-overlay-module__buttonRow___QOlIw {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.debug-overlay-module__consents___sIOPf select {
  width: 50%;
  height: 22px;
}`, "",{"version":3,"sources":["data:;charset=utf-8,/**%20function%20to%20get%20dimensions%0A%20%20usage%20example%20to%20get%20%60tablet%60%20value%20from%20%60$page-max-widths%60%0A%20%20.class%20%7B%0A%20%20%20%20max-width:%20dim($page-max-widths,%20tablet);%0A%20%20%7D%0A%0A%20*/%0A%0A@use%20'sass:map';%0A%0A@function%20dim($prop,%20$key)%20%7B%0A%20%20@return%20map.get($prop,%20$key);%0A%7D%0A","webpack://./client/app/react-components/debug-overlay/debug-overlay.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,uCAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,8CAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAMF;AAJE;;EAEE,YAAA;AAMJ;;AAFA;EACE,aAAA;EACA,8BAAA;AAKF;AAJE;EACE,iBAAA;AAMJ;;AAFA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,0BAAA;EACA,iBAAA;EACA,eAAA;AAKF;;AAFA;;;;EAIE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AAKF;;AAFA;EACE,SAAA;AAKF;;AAFA;EACE,gBAAA;AAKF;;AAFA;EACE,gBAAA;AAKF;;AAFA;;;;EAIE,UAAA;EACA,SAAA;AAKF;;AADE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAIJ;AAFI;EACE,gBAAA;AAIN;AAAE;EACE,UAAA;EACA,YAAA;AAEJ;AACE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AACJ;AACI;EACE,OAAA;EACA,WAAA;EACA,kBAAA;AACN;AACI;EACE,OAAA;EACA,YAAA;AACN;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AADF;AAGE;EACE,OAAA;AADJ;;AAKA;EACE,gBAAA;EACA,UAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AAFF;;AAKA;EACE,iBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,2DACE;EAEF,cAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAJF;;AAOA;EACE,SAAA;EACA,WAAA;AAJF;;AAQE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AALJ;AAQE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AANJ;AAQI;EACE,OAAA;EACA,YAAA;AANN;AASI;EACE,mBAAA;EACA,cAAA;AAPN;AAWE;EACE,mBAAA;EACA,WAAA;AATJ;AAYE;EACE,WAAA;AAVJ;AAaE;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAXJ;;AAeA;EACE,kBAAA;AAZF;AAcE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAZJ;AAeE;EACE,UAAA;EACA,YAAA;AAbJ","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `debug-overlay-module__overlay___T6rCP`,
	"header": `debug-overlay-module__header___d9ze8`,
	"content": `debug-overlay-module__content___T_tPF`,
	"storagePanel": `debug-overlay-module__storagePanel___TapH2`,
	"actionsPanel": `debug-overlay-module__actionsPanel___ybFXR`,
	"copyPanel": `debug-overlay-module__copyPanel___BolAy`,
	"dynatracePanel": `debug-overlay-module__dynatracePanel___MZpBo`,
	"cookiePanelDiv": `debug-overlay-module__cookiePanelDiv___HMbxB`,
	"actionColumn": `debug-overlay-module__actionColumn___ji5yQ`,
	"tokenSelect": `debug-overlay-module__tokenSelect___l3OBV`,
	"ottInput": `debug-overlay-module__ottInput___rZgwe`,
	"buttonRow": `debug-overlay-module__buttonRow___QOlIw`,
	"copyPanelButton": `debug-overlay-module__copyPanelButton___EJblD`,
	"overlayButton": `debug-overlay-module__overlayButton___PrL3s`,
	"datadogButtonsColumn": `debug-overlay-module__datadogButtonsColumn___D9hch`,
	"datadogButton": `debug-overlay-module__datadogButton___hVbKB`,
	"dtSection": `debug-overlay-module__dtSection___ON48W`,
	"dtInlineRow": `debug-overlay-module__dtInlineRow___P4SPE`,
	"dtSectionSubtitle": `debug-overlay-module__dtSectionSubtitle___hq9bj`,
	"fullWidth": `debug-overlay-module__fullWidth___VL5tj`,
	"dtIconButton": `debug-overlay-module__dtIconButton___vo2Tv`,
	"consents": `debug-overlay-module__consents___sIOPf`
};
export default ___CSS_LOADER_EXPORT___;
